import { render, staticRenderFns } from "./EditClientInfo.vue?vue&type=template&id=129cc93f&"
import script from "./EditClientInfo.vue?vue&type=script&lang=js&"
export * from "./EditClientInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditClientInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports